import { Spacer } from '../Spacer'

export function TerminosCondicionesContent() {
  return (
    <div className="flex flex-col gap-2">
      <h1 className={`w-full px-0 text-h4 text-neutral-900`}>
        TÉRMINOS Y CONDICIONES
      </h1>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>1. Información general</h2>
        <p>
          En cumplimiento con el deber de información establecido en la
          normativa vigente, se informa que el presente sitio web es titularidad
          de:
        </p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>
            <span className="font-bold">Razón social:</span> Gama Óptima, S.L.
          </li>
          <li>
            <span className="font-bold">CIF:</span> B75429340
          </li>
          <li>
            <span className="font-bold">Domicilio social:</span> Ronda General
            Mitre 38-40, Local comercial sótano 1, 08017 Barcelona
          </li>
        </ul>
        <p>
          El acceso y uso del sitio web atribuye la condición de usuario e
          implica la aceptación plena y sin reservas de los presentes Términos y
          Condiciones.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>2. Objeto del sitio web</h2>
        <p>
          El sitio web de Gama Óptima, S.L. tiene como finalidad proporcionar
          información sobre vehículos disponibles, servicios de compraventa,
          financiación, vehículos bajo demanda y otros servicios relacionados
          con el sector de la automoción, así como facilitar el contacto con la
          empresa.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>3. Uso del sitio web</h2>
        <p>
          El usuario se compromete a utilizar el sitio web de forma lícita,
          adecuada y conforme a la ley, la buena fe y el orden público. Queda
          prohibido el uso del sitio web con fines ilícitos o que puedan causar
          perjuicio a Gama Óptima, S.L. o a terceros.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>4. Información y disponibilidad</h2>
        <p>
          La información contenida en el sitio web es meramente informativa y no
          constituye una oferta contractual vinculante. Gama Óptima, S.L. se
          reserva el derecho a modificar, actualizar o eliminar contenidos,
          vehículos, precios o condiciones sin previo aviso.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>5. Responsabilidad</h2>
        <p>
          Gama Óptima, S.L. no se responsabiliza de posibles errores u omisiones
          en los contenidos del sitio web, ni de daños derivados del uso de la
          información publicada. Asimismo, no garantiza la disponibilidad
          continua del sitio web, aunque se adoptarán las medidas razonables
          para su correcto funcionamiento.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          6. Propiedad intelectual e industrial
        </h2>
        <p>
          Todos los contenidos del sitio web, incluyendo textos, imágenes,
          logotipos, diseño gráfico y código fuente, son propiedad de Gama
          Óptima, S.L. o de terceros autorizados, quedando prohibida su
          reproducción, distribución o uso sin autorización expresa.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>7. Protección de datos</h2>
        <p>
          El tratamiento de los datos personales se realizará conforme a lo
          establecido en la normativa vigente en materia de protección de datos.
          Para más información, el usuario puede consultar la Política de
          Privacidad disponible en este sitio web.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          8. Legislación aplicable y jurisdicción
        </h2>
        <p>
          Los presentes Términos y Condiciones se rigen por la legislación
          española. Para la resolución de cualquier controversia, las partes se
          someterán a los uzgados y tribunales de la ciudad de Barcelona, salvo
          que la normativa aplicable disponga lo contrario.
        </p>
      </section>
    </div>
  )
}
